export const API_URL = `https://blogsly-xkoy.onrender.com/api`;